import { Component, Input } from '@angular/core';

export type LotStatusTagVariant = 'started' | 'stopped' | 'paused' | 'cutting' | 'editing';

interface LotStatusTagDefinition {
  variant: LotStatusTagVariant;
  label: string;
}

@Component({
  selector: 'app-lot-status-tag',
  templateUrl: './lot-status-tag.component.html',
  styleUrls: ['./lot-status-tag.component.scss'],
})
export class LotStatusTagComponent {
  @Input() active = false;
  @Input() paused = false;
  @Input() cutting = false;
  @Input() editing = false;
  @Input() large = false;

  /**
   * Prioridad cuando varios estados son verdaderos a la vez: pausado y
   * en-corte/en-edición son overlays transitorios sobre el estado base
   * (iniciado/detenido), así que se muestran primero.
   */
  get status(): LotStatusTagDefinition {
    if (this.paused) {
      return { variant: 'paused', label: 'Pausado' };
    }
    if (this.cutting) {
      return { variant: 'cutting', label: 'En corte' };
    }
    if (this.editing) {
      return { variant: 'editing', label: 'En edición' };
    }
    return this.active
      ? { variant: 'started', label: 'Iniciado' }
      : { variant: 'stopped', label: 'Detenido' };
  }
}
